<script lang="ts" setup>
import { ref } from 'vue';
import { useChecksStore } from '@/stores/checksStore';

const isSyncing = ref(false);
const checkStore = useChecksStore();

const sync = async () => {
  isSyncing.value = true;
  await checkStore.getChecks();
  isSyncing.value = false;
  setTimeout(async() => await sync(), 1800000);
};
setTimeout(async () => {
  await sync();
}, 3000);

</script>

<template>
  <i class="hidden fas fa-rotate" @click="sync" v-if="false"></i>
</template>

<style>
  .hidden {opacity: 0;}
</style>